import Image from "@components/common/OldCloudinaryImage";
import { Link } from "gatsby";
import React from "react";
import { AiOutlineAndroid, AiOutlineApple } from "react-icons/ai";
import CustomAlert from "../common/CustomAlert";

const Applications = ({ items }) => {
    return (
        <>
            <div className="applications-container">
                {items && items.length > 0 ? (
                    <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-3">
                        {items.map((p) => {
                            return <Application key={p.id} item={p} />;
                        })}
                    </div>
                ) : (
                    <CustomAlert type="info" className="mt-5">
                        No hay aplicaciones disponibles.
                    </CustomAlert>
                )}
            </div>
        </>
    );
};

export default Applications;

const Application = ({ item }) => {
    const images = item.images || [];
    const defaultImage = images.length > 0 ? images[0] : "products/common/0";

    return (
        <>
            <div className="overflow-hidden rounded border border-gray-300 border-opacity-50 shadow duration-300 hover:shadow-xl">
                <Image
                    alt={item.name}
                    filename={defaultImage}
                    className="h-80"
                />
                <div className="my-8 flex items-center justify-evenly">
                    {item.ios_url && (
                        <a
                            href={item.ios_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rounded bg-black p-3 leading-none shadow duration-300 hover:bg-opacity-75"
                            title="Descargar la versión para iOS"
                        >
                            <AiOutlineApple
                                className="h-5 w-5 text-white"
                                style={{ verticalAlign: "middle" }}
                            />
                        </a>
                    )}

                    {item.android_url && (
                        <a
                            href={item.android_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Descargar la versión para Android"
                            className="rounded bg-green-700 p-3 leading-none shadow duration-300 hover:bg-opacity-75"
                        >
                            <AiOutlineAndroid
                                className="h-5 w-5 text-white"
                                style={{ verticalAlign: "middle" }}
                            />
                        </a>
                    )}
                </div>
                <div>
                    {item.stock ? (
                        <Link
                            to={item.link}
                            title={
                                item.stock
                                    ? "Más información"
                                    : "Pronto disponible"
                            }
                        >
                            <div className="mx-10">
                                <Image
                                    filename={`apps/${item.name}/full-icon`}
                                    alt={item.name}
                                />
                            </div>
                            <h3 className="font-slim m-5 mt-3 text-center text-xs uppercase leading-5 text-gray-600">
                                {item.description}
                            </h3>
                        </Link>
                    ) : (
                        <>
                            <div className="mx-10">
                                <Image
                                    filename={`apps/${item.name}/full-icon`}
                                    alt={item.name}
                                />
                            </div>
                            <h3 className="font-slim m-5 mt-3 text-center text-xs uppercase leading-5 text-gray-600">
                                {item.description}
                            </h3>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
